import React, { useState } from 'react';
import { LogoPlaceholder } from './CommonComponents';
import { ExternalLink, Globe, Linkedin, Facebook } from 'lucide-react';
import { usePortfolioTranslation } from '../../hooks/usePortfolioTranslation';

export const EducationCard = ({ school, degree, period, grade, activities, logo, website, socialLinks, translationKey }) => {
    const { translateEducation } = usePortfolioTranslation();
    const [imageError, setImageError] = useState(false);

    const translatedEducation = translateEducation(translationKey);
    const displaySchool = translatedEducation?.institution || school;
    const displayDegree = translatedEducation?.degree || degree;

    const handleImageError = () => {
        setImageError(true);
    };

    return (
        <div className="flex gap-4 group">
            <div className="hidden sm:block flex-shrink-0">
                {logo && !imageError ? (
                    <img
                        src={logo}
                        alt={`${school} logo`}
                        className="w-12 h-12 rounded-lg object-contain transition-transform group-hover:scale-110 duration-300 company-logo"
                        onError={handleImageError}
                    />
                ) : (
                    <LogoPlaceholder name={school} />
                )}
            </div>
            <div className="flex-1 bg-[#141414] p-6 rounded-xl border border-[#732424]/20 hover:border-[#d92323]/50 transition-all duration-300">
                <div className="flex flex-col sm:flex-row justify-between mb-2">
                    <div className="flex items-start gap-2">
                        <h3 className="text-lg font-bold text-white group-hover:text-[#d92323] transition-colors">{displaySchool}</h3>
                        {website && (
                            <a
                                href={website}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#7b7b7b] hover:text-[#d92323] transition-colors mt-1"
                                title="Visit Website"
                            >
                                <ExternalLink className="w-4 h-4" />
                            </a>
                        )}
                    </div>
                    <span className="text-[#7b7b7b] text-sm font-mono">{period}</span>
                </div>
                <p className="text-white font-medium mb-1">{displayDegree}</p>
                {grade && <p className="text-[#d92323] text-sm mb-3 font-mono">{grade}</p>}

                {/* Social Links */}
                {socialLinks && (
                    <div className="flex items-center gap-2 mb-3">
                        {socialLinks.website && (
                            <a
                                href={socialLinks.website}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#7b7b7b] hover:text-[#d92323] transition-colors social-link"
                                title="Website"
                            >
                                <Globe className="w-4 h-4" />
                            </a>
                        )}
                        {socialLinks.linkedin && (
                            <a
                                href={socialLinks.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#7b7b7b] hover:text-[#0077b5] transition-colors social-link"
                                title="LinkedIn"
                            >
                                <Linkedin className="w-4 h-4" />
                            </a>
                        )}
                        {socialLinks.facebook && (
                            <a
                                href={socialLinks.facebook}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#7b7b7b] hover:text-[#1877f2] transition-colors social-link"
                                title="Facebook"
                            >
                                <Facebook className="w-4 h-4" />
                            </a>
                        )}
                    </div>
                )}

                {activities && (
                    <div className="text-sm text-[#7b7b7b] border-t border-[#732424]/20 pt-3 mt-2">
                        <strong className="text-white/80">Activities:</strong> {activities}
                    </div>
                )}
            </div>
        </div>
    );
};